import { render } from "./TaskTemplateDetailView.vue?vue&type=template&id=07f5696b&scoped=true"
import script from "./TaskTemplateDetailView.vue?vue&type=script&lang=js"
export * from "./TaskTemplateDetailView.vue?vue&type=script&lang=js"

import "./TaskTemplateDetailView.vue?vue&type=style&index=0&id=07f5696b&scoped=true&lang=css"
import "./TaskTemplateDetailView.vue?vue&type=style&index=1&id=07f5696b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07f5696b"]])

export default __exports__